let locales = {
    parametersTemplates_name: 'Nome',
    parametersTemplates_subject: 'Oggetto',
    parametersTemplates_template: 'Template',
};

export default locales;